var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tooltip',{attrs:{"position":_vm.position,"hideControls":_vm.hideControls}},[_c('div',{class:_vm.$style.container},[_c('innate',{attrs:{"innate":_vm.innate,"hidden":_vm.isInnateHidden}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }